import { getViewport, loadFiles } from "@/canvasController/helpers";
import { canv } from '@/canv/global.js'
import { logException, matrixTranslate, MakeRequest } from '@/canv/utils.js'
import { zoomToVis } from '@/animations/zoomToVis.js'
import { switchCopyingToDragging } from "@/actionManager/utils.js";
import hotkeys from 'hotkeys-js';
import { isWidgetWithTextOrTextWidgetOnly } from "@/tools/cursorTool/utils.js";
import { selectionManager } from "@/tools/cursorTool";
import { ACCOUNT_UPDATE_V2, BOARD_ZOOM_GET_V2, BOARD_ZOOM_SET_V2 } from "@/api/apiEndpoints";
import { eventEmitter } from "@/eventEmitter";
import { rafThrottle } from "@/helpers/rafThrottle";

export class actionManager {
    constructor() {
        this.actionSymbol = "Ctrl";
        this.actionSymbolName = "Ctrl";
        this.altSymbol = "Alt";
        this.os = "Windows";

        if (navigator.appVersion.indexOf("Win") != -1) this.os = "Windows";
        if (navigator.appVersion.indexOf("Mac") != -1) this.os = "MacOS";
        if (navigator.appVersion.indexOf("X11") != -1) this.os = "UNIX";
        if (navigator.appVersion.indexOf("Linux") != -1) this.os = "Linux";

        if (this.os == "MacOS") {
            this.actionSymbol = "&#8984;";
            this.actionSymbolName = "Cmd";
            this.altSymbol = "&#8997;";
        }
    }

    getActionPoint() {
        var x = this.lastX * canv.dpr;
        var y = this.lastY * canv.dpr;

        var px = x + y * canv.m[2] - canv.m[4];
        var py = canv.m[1] * x + y - canv.m[5];

        return {
            x: px / canv.m[0],
            y: py / canv.m[3],
        };
    }

    getPreActionPoint() {
        var x = this.preX * canv.dpr;
        var y = this.preY * canv.dpr;

        var px = x + y * canv.m[2] - canv.m[4];
        var py = canv.m[1] * x + y - canv.m[5];

        return {
            x: px / canv.m[0],
            y: py / canv.m[3],
        };
    }

    getConstant(value) {
        return value * canv.dpr;
    }

    getZoomConstant(value) {
        return (value * canv.dpr) / canv.m[0];
    }

    // EventListeners

    initEventListeners() {
        window.addEventListener("resize", (event) => {
            canv.adjustCanvas();
        });

        window.addEventListener("beforeunload", this.viewSaveSave);

        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
            } else {
                if (
                    canv.intercom.socket.readyState == 2 ||
                    canv.intercom.socket.readyState == 3
                ) {
                    canv.appInterface.reconnectWindow.show();
                }
            }
        });
        canv.canvas.addEventListener("dragover", (e) => e.preventDefault());
        canv.canvas.addEventListener("drop", this.dropElement);

        document.addEventListener("contextmenu", (event) => event.preventDefault());

        canv.canvas.addEventListener("dblclick", this.dblClickListener, false);
        canv.canvas.addEventListener("click", this.clickListener, false);

        canv.canvas.addEventListener(
            "pointerdown",
            this.pointerDownListener,
            false,
        );
        document.addEventListener("pointermove", this.pointerMoveListener, false);
        document.addEventListener("pointerup", this.pointerUpListener, false);
        canv.canvas.addEventListener(
            "pointercancel",
            this.pointerUpListener,
            false,
        );

        canv.canvas.addEventListener("touchstart", this.touchStartListener, false);
        canv.canvas.addEventListener("touchmove", this.touchMoveListener, false);

        /////////// Дальше зум и премещение холста ///////////////////

        canv.canvas.addEventListener("wheel", this.handleTouchpadGesture, false);

        //document.addEventListener('keydown', handleKeyboardDown, false);
        document.addEventListener("keyup", this.handleKeyboardUp, false);

        document.addEventListener("keypress", (event) => {
            if (event.ctrlKey || event.metaKey || event.altKey) return;

            canv.keyboard.command = event.key;
            canv.keyboard.code = event.code;
            canv.keyboard.isSymbol = true;
            canv.actionManager.handleKeyboardDown(event);
        });

        // Убираем зуминг и скролиинг везде кроме канваса
        document.addEventListener("wheel", this.handleDocumentTouchpadGesture, {
            passive: false,
        });

        hotkeys("*", (event, handler) => {
            var detectedAny = false;

            if (
                (event.code === "Home" && event.shiftKey) ||
                (event.code === "ArrowLeft" && event.shiftKey && event.metaKey)
            ) {
                canv.keyboard.command = "shift+home";
                detectedAny = true;
            } else if (
                (event.code === "End" && event.shiftKey) ||
                (event.code === "ArrowRight" && event.shiftKey && event.metaKey)
            ) {
                canv.keyboard.command = "shift+end";
                detectedAny = true;
            } else if (event.code == "ArrowLeft") {
                if (!event.shiftKey) {
                    canv.keyboard.command = "ArrowLeft";
                } else {
                    canv.keyboard.command = "ArrowLeft+shift";
                }
                detectedAny = true;
            } else if (event.code == "ArrowRight") {
                if (!event.shiftKey) {
                    canv.keyboard.command = "ArrowRight";
                } else {
                    canv.keyboard.command = "ArrowRight+shift";
                }
                detectedAny = true;
            } else if (event.code == "ArrowDown") {
                if (!event.shiftKey) {
                    canv.keyboard.command = "ArrowDown";
                } else {
                    canv.keyboard.command = "ArrowDown+shift";
                }
                detectedAny = true;
            } else if (event.code == "ArrowUp") {
                if (!event.shiftKey) {
                    canv.keyboard.command = "ArrowUp";
                } else {
                    canv.keyboard.command = "ArrowUp+shift";
                }
                detectedAny = true;
            } else if (event.code == "ShiftLeft" || event.code == "ShiftRight") {
                canv.keyboard.command = "Shift";
                detectedAny = true;
            } else if (event.code === "AltLeft" || event.code === "AltRight" || event.key === "Alt") {
                canv.keyboard.command = "alt";
                detectedAny = true;
            } else if (event.code == "Backspace") {
                canv.keyboard.command = "Backspace";
                detectedAny = true;
            } else if (event.code === "Delete") {
                canv.keyboard.command = "Delete";
                detectedAny = true;
            }

            if (detectedAny) {
                canv.keyboard.isSymbol = false;
                canv.actionManager.handleKeyboardDown(event);
            }
        });

        hotkeys("escape", (event, handler) => {
            canv.keyboard.command = "escape";
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+a, cmd+a", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event, canv.isBoardModeViewCopy());
        });

        hotkeys("ctrl+z, cmd+z", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+shift+z, cmd+shift+z", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+x, cmd+x", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+c, cmd+c", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event, canv.isBoardModeViewCopy());
        });

        hotkeys("ctrl+d, cmd+d", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+v, cmd+v", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+g, cmd+g", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+shift+g, cmd+shift+g", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+], cmd+]", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+[, cmd+[", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+=, cmd+=", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+-, cmd+-", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+enter, cmd+enter", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+shift+enter, cmd+shift+enter", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+f, cmd+f", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("ctrl+b, cmd+b", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("shift+end, shift+cmd+arrowRight", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys("shift+home, shift+cmd+arrowLeft", (event, handler) => {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys('ctrl+0, cmd+0', function (event, handler) {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });

        hotkeys('alt+1', function (event, handler) {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });
        hotkeys('alt+2', function (event, handler) {
            canv.keyboard.command = handler["shortcut"];
            canv.keyboard.isSymbol = false;
            canv.actionManager.handleKeyboardDown(event);
        });
    }

    dropElement = (e) => {
        e.preventDefault();
        if (canv.appInterface.activeVote.isOpen || this.isActiveOrNewVoteMode()) return;

        const files = e.dataTransfer.files;
        if (files.length > 0) {
            loadFiles(files, {
                x: e.pageX,
                y: e.pageY,
            });
        }
    };

    pointerDownListener = (evt) => {
        evt.preventDefault();
        // Очистка стейта при потере фокуса и не срабатывании handleKeyboardUp, например переход в создание скриншота на MacOS
        // Если ни один модификатор физически не нажат и стейт не пуст — очищаем наш стейт
        if (!evt.metaKey && !evt.shiftKey && !evt.altKey && !evt.ctrlKey) {
            if (canv.keyboard.command) canv.keyboard.command = "";
            if (canv.keyboard.code) canv.keyboard.code = "";
        }

        if (evt.pointerType === "mouse") {
            try {
                canv.actionManager.startClickMove();

                const isRightButtonClicked = evt.which === 3 || evt.button === 2;

                canv.contextMenu.hide();

                canv.actionManager.lastX =
                    evt.offsetX || evt.pageX - canv.canvas.offsetLeft;
                canv.actionManager.lastY =
                    evt.offsetY || evt.pageY - canv.canvas.offsetTop;

                if (isRightButtonClicked) {
                    canv.actionManager.rightButtonClicked = true;
                    return;
                }

                canv.toolBox.TryAction("mousedown");

                canv.actionManager.preX = canv.actionManager.lastX;
                canv.actionManager.preY = canv.actionManager.lastY;

                canv.redraw();
            } catch (e) {
                logException(e);
            }
        }
    }
    pointerMoveListener(evt) {
        evt.preventDefault();

        // когда мы зажимаем ПКМ и заводим за границу канваса
        // и там отпускаем ПКМ при возвращении на канвас мы
        // должны снять rightButtonClicked что бы не вертеть доску
        if (canv.actionManager.rightButtonClicked && evt.buttons != 2) {
            canv.actionManager.rightButtonClicked = false;
            return;
        }

        if (evt.pointerType === "mouse") {
            try {
                canv.actionManager.stepClickMove();
                canv.actionManager.lastX =
                    evt.clientX || evt.pageX - canv.canvas.offsetLeft;
                canv.actionManager.lastY =
                    evt.clientY || evt.pageY - canv.canvas.offsetTop;
                canv.actionManager.lastMoveEvt = evt;

                if (
                    canv.actionManager.mode == "mouse" &&
                    canv.actionManager.rightButtonClicked
                ) {
                    canv.multiManager.resetViewSubscribe();
                    matrixTranslate(evt.movementX * canv.dpr, evt.movementY * canv.dpr);
                    canv.ctx.setTransform(
                        canv.m[0],
                        0,
                        0,
                        canv.m[3],
                        canv.m[4],
                        canv.m[5],
                    );
                    canv.toolBox.TryAction("touchpadGestureDragging");
                    canv.redraw();
                    return;
                }

                canv.toolBox.TryAction("mousemove");

                canv.actionManager.preX = canv.actionManager.lastX;
                canv.actionManager.preY = canv.actionManager.lastY;
                canv.multiManager.enableCursorUpdate();
            } catch (e) {
                logException(e);
            }
        }
    }
    pointerUpListener(evt) {
        evt.preventDefault();

        this.prevTouches = [];
        this.gestureType = undefined;

        try {
            const isRightButtonClicked = evt.which === 3 || evt.button === 2;
            if (canv.appInterface.activeVote.isOpen && isRightButtonClicked) return;

            // используется только для майндмапой, чтобы смотреть клик был правой кнопкой или нет
            // пользоваться полем rightButtonClicked не получается, так как она меняется назад на false до срабатывания события mouseup
            canv.actionManager.rightButtonClickedPrevValue =
                canv.actionManager.rightButtonClicked;

            if (isRightButtonClicked) {
                canv.actionManager.rightButtonClicked = false;
                if (canv.actionManager.isClick()) {
                    if (canv.toolBox.currentTool != canv.toolBox.getFirstTool()) {
                        canv.toolBox.switchTo(canv.toolBox.getFirstTool());
                    }

                    if (!selectionManager.isOverSelected()) {
                        canv.toolBox.TryAction("mousedown");
                        canv.toolBox.TryAction("mouseup");
                    }

                    canv.contextMenu.show();
                    canv.redraw();
                    return;
                }
            }

            const targetIsCanvas = evt.target === canv.canvas;

            // mouseup на документе должно срабатывать только если
            // мы что то переноси, а не кликаем. Таким образом мы можем
            // растянуть элемент за канвас, нарисовать линию за канвас
            // но при клике на боковое меню или за пределами канваса
            // мы не можем создавать элементы
            if (canv.actionManager.clickMove > 1 || targetIsCanvas) {
                canv.toolBox.TryAction("mouseup");
                canv.redraw();
            }
        } catch (e) {
            logException(e);
        }

        canv.actionManager.stopClickMove();
    }

    touchStartListener = (evt) => {
        evt.preventDefault();

        this.gestureType = undefined;
        this.prevTouches = [];
        const touches = [...evt.touches];
        this.lastTouches = touches;

        if (touches.length > 2) {
            return;
        }

        canv.actionManager.startClickMove();
        canv.contextMenu.hide();

        if (touches.length === 1) {
            // стандартное поведение, как для мышки
            const touch = evt.touches[0];
            canv.actionManager.lastX =
                touch.offsetX || touch.pageX - canv.canvas.offsetLeft;
            canv.actionManager.lastY =
                touch.offsetY || touch.pageY - canv.canvas.offsetTop;
        } else if (touches.length === 2) {
            // 2 пальца
            const { x, y } = touches
                .map((touch) => {
                    return {
                        x: touch.offsetX || touch.pageX - canv.canvas.offsetLeft,
                        y: touch.offsetY || touch.pageY - canv.canvas.offsetTop,
                    };
                })
                .reduce(
                    ({ x: x1, y: y1 }, { x: x2, y: y2 }) => {
                        return {
                            x: (x1 + x2) / 2,
                            y: (y1 + y2) / 2,
                        };
                    },
                    { x: 0, y: 0 },
                );

            canv.actionManager.lastX = x;
            canv.actionManager.lastY = y;
        }
        canv.toolBox.TryAction("mousedown");
        canv.actionManager.preX = canv.actionManager.lastX;
        canv.actionManager.preY = canv.actionManager.lastY;
        this.prevTouches = this.lastTouches;

        canv.redraw();
    };
    touchMoveListener = (evt) => {
        evt.preventDefault();

        const touches = [...evt.touches];
        if (touches.length > 2) {
            return;
        }

        this.lastTouches = touches;

        canv.actionManager.stepClickMove();

        if (touches.length === 1) {
            // стандартное поведение, как для мышки
            const touch = touches[0];
            canv.actionManager.lastX =
                touch.offsetX || touch.pageX - canv.canvas.offsetLeft;
            canv.actionManager.lastY =
                touch.offsetY || touch.pageY - canv.canvas.offsetTop;
            canv.actionManager.lastMoveEvt = evt;

            canv.toolBox.TryAction("mousemove");

            canv.actionManager.preX = canv.actionManager.lastX;
            canv.actionManager.preY = canv.actionManager.lastY;
        } else if (touches.length === 2 && this.prevTouches.length === 2) {
            // 2 пальца
            // если тип жеста не определен - определяем
            if (this.gestureType === undefined) {
                // вычисляем разницу в движении пальцев
                const distanceStart = Math.hypot(
                    this.prevTouches[0].clientX - this.prevTouches[1].clientX,
                    this.prevTouches[0].clientY - this.prevTouches[1].clientY,
                );
                const distanceNow = Math.hypot(
                    touches[0].clientX - touches[1].clientX,
                    touches[0].clientY - touches[1].clientY,
                );
                const distanceDelta = Math.abs(distanceStart - distanceNow);

                const moveFirst = Math.hypot(
                    this.prevTouches[0].clientX - touches[0].clientX,
                    this.prevTouches[0].clientY - touches[0].clientY,
                );
                const moveSecond = Math.hypot(
                    this.prevTouches[1].clientX - touches[1].clientX,
                    this.prevTouches[1].clientY - touches[1].clientY,
                );
                const moveDelta = (moveFirst + moveSecond) / 2;
                if (distanceDelta > moveDelta) {
                    // пользователь раздвигает/сводит пальцы
                    this.gestureType = "pinch";
                    // сохраняем точку посередине, чтобы зумить по ней
                    canv.actionManager.lastX =
                        (touches[0].clientX + touches[1].clientX) / 2 -
                        canv.canvas.offsetLeft;
                    canv.actionManager.lastY =
                        (touches[0].clientY + touches[1].clientY) / 2 -
                        canv.canvas.offsetTop;
                } else {
                    // двигает пальцы вместе
                    this.gestureType = "pan";
                }
            }

            if (this.gestureType === "pan") {
                // перемещение
                const dx =
                    (touches[0].clientX -
                        this.prevTouches[0].clientX +
                        touches[1].clientX -
                        this.prevTouches[1].clientX) /
                    2;
                const dy =
                    (touches[0].clientY -
                        this.prevTouches[0].clientY +
                        touches[1].clientY -
                        this.prevTouches[1].clientY) /
                    2;
                canv.actionManager.dragAction(dx * canv.dpr, dy * canv.dpr);
            } else if (this.gestureType === "pinch") {
                // масштабирование
                const distanceStart = Math.hypot(
                    this.prevTouches[0].clientX - this.prevTouches[1].clientX,
                    this.prevTouches[0].clientY - this.prevTouches[1].clientY,
                );

                const distanceNow = Math.hypot(
                    touches[0].clientX - touches[1].clientX,
                    touches[0].clientY - touches[1].clientY,
                );

                const distanceDelta = distanceNow - distanceStart;
                const actionPoint = canv.actionManager.getActionPoint();
                canv.actionManager.handleZoomFor2(distanceDelta * -1, {
                    x: actionPoint.x * canv.m[0],
                    y: actionPoint.y * canv.m[0],
                });
            }
        }

        this.prevTouches = this.lastTouches;
        canv.redraw();
    };

    dblClickListener(evt) {
        try {
            canv.toolBox.TryAction("dblclick");
            canv.redraw();
        } catch (e) {
            logException(e);
        }
    }

    clickListener = (evt) => {
        if (window.self !== window.top) {
            window.focus();
        }

        if (evt.detail === 3) {
            canv.toolBox.TryAction("tripleclick");
        }
    };

    isActiveOrNewVoteMode = () => {
        return canv.appInterface.activeVote.isOpen || (canv.appInterface.voteWindow.opened &&
            canv.appInterface.voteWindow.activeTab === "new")
    }

    handleKeyboardDown(e, force = false) {
        if (canv.isBoardModeView() && !force) return;
        if (canv.toolBox.currentTool.name === "voteTool") return;
        if (canv.toolBox.currentTool.name === "activeVoteScreen") return;

        try {
            const isSelectedOnlyOneTextWidget = isWidgetWithTextOrTextWidgetOnly();

            const isInteractionMode = canv.toolBox
                .TryGetToolByName("cursorTool")
                .isMode("interaction");

            // Нужно, например, чтобы когда вводятся символы в input of widgetMenu размера текста, они не писались в стикер
            // inputFocused == 2 нужен для Enter. Без этого (else if) если нажать в input enter, то enter обработается (поставиться в стикер и т.д.)
            // Общее правило - для всех input надо ловить focus, blur и проставлять canv.appInterface.inputFocused
            if (canv.appInterface.inputFocused == 1 || this.isActiveOrNewVoteMode()) {
                return;
            } else if (canv.appInterface.inputFocused == 2) {
                canv.appInterface.inputFocused = 0;
                return;
            }

            if (canv.keyboard.isUndoCommand()) {
                e.preventDefault();
                e.stopPropagation();
                canv.eventManager.Undo();
                return;
            }

            if (!isInteractionMode && canv.keyboard.isLeftArrow()) {
                var props = {
                    0: canv.m[0],
                    3: canv.m[3],
                    4: canv.m[4] + canv.actionManager.getConstant(50),
                    5: canv.m[5],
                };

                canv.actionManager.softDragAction(props);
                return;
            }

            if (!isInteractionMode && canv.keyboard.isRightArrow()) {
                var props = {
                    0: canv.m[0],
                    3: canv.m[3],
                    4: canv.m[4] - canv.actionManager.getConstant(50),
                    5: canv.m[5],
                };

                canv.actionManager.softDragAction(props);
                return;
            }

            if (!isInteractionMode && canv.keyboard.isUpArrow()) {
                var props = {
                    0: canv.m[0],
                    3: canv.m[3],
                    4: canv.m[4],
                    5: canv.m[5] + canv.actionManager.getConstant(50),
                };

                canv.actionManager.softDragAction(props);
                return;
            }

            if (!isInteractionMode && canv.keyboard.isDownArrow()) {
                var props = {
                    0: canv.m[0],
                    3: canv.m[3],
                    4: canv.m[4],
                    5: canv.m[5] - canv.actionManager.getConstant(50),
                };

                canv.actionManager.softDragAction(props);
                return;
            }

            if (!isInteractionMode && canv.keyboard.isEqual()) {
                canv.actionManager.zoomPlus();
                return;
            }

            if (!isInteractionMode && canv.keyboard.isDash()) {
                canv.actionManager.zoomMinus();
                return;
            }

            if (canv.keyboard.isZoomPlus()) {
                canv.actionManager.zoomPlus();
                e.preventDefault();
                return;
            }

            if (canv.keyboard.isZoomMinus()) {
                canv.actionManager.zoomMinus();
                e.preventDefault();
                return;
            }

            if (canv.keyboard.isRedoCommand()) {
                canv.eventManager.Redo();
                return;
            }

            if (!isInteractionMode && canv.keyboard.isEscCommand()) {
                if (canv.appInterface.voteWindow.opened && canv.appInterface.voteWindow.activeTab === "new") {
                    canv.toolBox.switchToByName("voteTool");
                } else if (canv.appInterface.activeVote.isOpen) {
                    canv.toolBox.switchToByName("activeVoteTool");
                } else {
                    const cursorTool = canv.toolBox.TryGetToolByName("cursorTool");

                    if (cursorTool?.fastActionGroup) {
                        // Делаем beforeDeletion потому-что группы как таковой нет в canv.canvasController
                        // Она просто локально существует в cursorTool
                        cursorTool.fastActionGroup.beforeDeletion();
                        cursorTool.setSelectedAndInteraction(cursorTool.fastActionGroup);
                    }

                    canv.toolBox.switchToByName("cursorTool");
                }
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isPenToolCommand()
            ) {
                const penTool = canv.toolBox.TryGetToolByName("penTool");
                const subMenu = document.getElementsByClassName("penTool_subMenu")[0];
                const isMenuOpenWithOtherTool = penTool.mode !== "pen" && subMenu;

                canv.toolBox.switchTo(penTool, !isMenuOpenWithOtherTool);
                penTool.setMode("pen");
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isCardToolCommand()
            ) {
                const cardTool = canv.toolBox.TryGetToolByName("cardTool");
                canv.toolBox.switchTo(cardTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isShapeToolCommand()
            ) {
                const shapeTool = canv.toolBox.TryGetToolByName("shapeTool");
                canv.toolBox.switchTo(shapeTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isShapeToolCommandWithCircleMode()
            ) {
                canv.toolBox.switchToShapeTool("circle");
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isShapeToolCommandWithRectMode()
            ) {
                canv.toolBox.switchToShapeTool("rect");
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isStickerToolCommand()
            ) {
                var stickerTool = canv.toolBox.TryGetToolByName("stickerTool");
                canv.toolBox.switchTo(stickerTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isTextToolCommand()
            ) {
                var textTool = canv.toolBox.TryGetToolByName("textTool");
                canv.toolBox.switchTo(textTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isCommentToolCommand() &&
                !canv.isGuest()
            ) {
                const commentTool = canv.toolBox.TryGetToolByName("commentTool");
                canv.toolBox.switchTo(commentTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isMouseOrHandCommand()
            ) {
                const dragTool = canv.toolBox.TryGetToolByName("dragTool");
                const cursorTool = canv.toolBox.TryGetToolByName("cursorTool");

                canv.toolBox.switchTo(dragTool.isSelected ? cursorTool : dragTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isArrowToolCommand()
            ) {
                var arrowTool = canv.toolBox.TryGetToolByName("arrowTool");
                canv.toolBox.switchTo(arrowTool);
            }

            if (
                !isInteractionMode &&
                !isSelectedOnlyOneTextWidget &&
                canv.keyboard.isEraserToolCommand()
            ) {
                const penTool = canv.toolBox.TryGetToolByName("penTool");
                const subMenu = document.getElementsByClassName("penTool_subMenu")[0];
                const isMenuOpenWithOtherTool = penTool.mode !== "eraser" && subMenu;

                canv.toolBox.switchTo(penTool, !isMenuOpenWithOtherTool);
                penTool.setMode("eraser");
            }

            if (!isInteractionMode && canv.keyboard.isSearchShortcut()) {
                // нужен, иначе выводится и окно поиска в браузере
                e.preventDefault();
                return;
            }

            // функционал должен быть доступен и при редактировании текста, то есть в isInteractionMode
            if (canv.keyboard.isBoldShortcut()) {

                e.preventDefault();
                return;
            }

            if (!isInteractionMode && canv.keyboard.isZoomToSelected()) {
                canv.zoomToSelected(canv.canvasController.selected);
            }

            if (!isInteractionMode && canv.keyboard.isZoomToFit()) {
                canv.zoomToSelected(canv.canvasController.items);
            }

            if (!isInteractionMode && canv.keyboard.isZoomTo100()) {
                canv.zoomTo100();
            }


            canv.toolBox.TryAction("keyboardDown");
            canv.redraw();
            if (!canv.appInterface.inputFocused) {
                // нужен, иначе cmd + [ кроме bring to front еще переключает страницу браузера на предыдущую
                return e.preventDefault() && false;
            }
        } catch (e) {
            logException(e);
        }
    }

    handleKeyboardUp(e) {
        canv.keyboard.command = "";
        canv.keyboard.code = "";

        const isAltKey = e?.code === 'AltLeft' || e?.code === 'AltRight' || e?.key === 'Alt';
        if (!isAltKey || !canv.actionManager.isMouseDown()) return;

        const cursor = canv.toolBox.TryGetToolByName("cursorTool");
        if (cursor?.isMode?.("copying")) {
            switchCopyingToDragging(canv, cursor);
        }
    }

    // clickMove

    startClickMove() {
        canv.actionManager.clickMove = 1;
    }

    stopClickMove() {
        canv.actionManager.clickMove = 0;
    }

    stepClickMove() {
        if (canv.actionManager.clickMove > 0 && canv.actionManager.clickMove < 30) {
            // < 10 это защита, если вдруг clickMove будет бесконечно рости
            canv.actionManager.clickMove++;
        }
    }

    getClickMoveValue() {
        return canv.actionManager.clickMove;
    }

    isClick() {
        // return canv.actionManager.clickMove === 1;
        // тут решается проблема двух корнер кейсов -
        // 1 wm_filter_submenu меню когда выбрал стикер и фигуру и потом фильтруешь фигуру,
        // 2 кликодраги - это создавало впечателение что клик не сработал, на самом деле это был не клик а частично драг - 2 у него было клик мув
        // сечас это условие ниже почему-то работает для обоих кейсов. с < 3  работал только для кликов, меню лагало.
        return this.clickMove > 0 && this.clickMove <= this.clickMoveThreshold;
    }

    isMouseDown() {
        return canv.actionManager.clickMove > 0;
    }

    // Tools
    setTrackpadMode() {
        this.mode = "trackpad";
    }

    setMode(mode) {
        this.mode = mode;

        if (canv.isGrantedAccess()) return;

        if (canv.getInitDataProp("userToken") !== "") {
            MakeRequest(
                ACCOUNT_UPDATE_V2,
                {
                    navigationMode: mode,
                    token: canv.getInitDataProp("userToken"),
                },
                true,
            );
        }
    }

    // zoom, translate

    handleTouchpadGesture(evt) {
        canv.multiManager.resetViewSubscribe();
        canv.appInterface.textWidgetLinkWindow.locate();

        // При прокуртки колесика мышки вызывается else (touchpadGestureDragging) (!evt.ctrlKey)
        canv.multiManager.enableCursorUpdate();
        canv.contextMenu.hide();
        if (evt.ctrlKey || canv.actionManager.mode == "mouse") {
            canv.actionManager.handleZoomingExp2(evt);
            canv.toolBox.TryAction("touchpadGestureZoom");
        } else {
            canv.actionManager.dragAction(
                -evt.deltaX * canv.dpr,
                -evt.deltaY * canv.dpr,
            );
        }
    }

    handleDocumentTouchpadGesture(e) {
        var shouldDo = false;
        var path = e.composedPath();
        for (var i = 0; i < path.length; i++) {
            if (path[i].classList == undefined) continue;
            var iff =
                (path[i].classList.contains("widgetMenu") ||
                    path[i].classList.contains("widgetSubMenu") ||
                    path[i].classList.contains("dragThrowAble")) &&
                !path[i].classList.contains("scrollable");
            if (iff) {
                shouldDo = true;
                break;
            }
        }

        if (shouldDo) {
            canv.actionManager.handleTouchpadGesture(e);
        }

        for (var i = 0; i < path.length; i++) {
            if (
                path[i].classList != null &&
                path[i].classList.contains("scrollable")
            ) {
                return;
            }
        }
        e.preventDefault();
        return false;
    }

    handleZoomingExp2(evt) {
        var pt = canv.actionManager.getActionPoint();
        pt.x = pt.x * canv.m[0];
        pt.y = pt.y * canv.m[0];
        canv.actionManager.handleZoomFor2(evt.deltaY, pt);

        return evt.preventDefault() && false;
    }

    handleZoomFor2(deltaY, pt) {
        var zoomAlpha = 0.01 * -deltaY;

        if (canv.actionManager.mode == "mouse") {
            // Для зума колесиком уменьшаем зум на каждый скролл
            zoomAlpha *= 0.1;
        }

        if (zoomAlpha > 0) {
            if (
                canv.m[0] + zoomAlpha * canv.m[0] > this.getConstant(this.maxZoom) ||
                canv.m[3] + zoomAlpha * canv.m[3] > this.getConstant(this.maxZoom)
            ) {
                var customZoomAlpha = this.getConstant(this.maxZoom) / canv.m[0] - 1;

                canv.m[0] = this.getConstant(this.maxZoom);
                canv.m[3] = this.getConstant(this.maxZoom);

                canv.m[4] -= pt.x * customZoomAlpha;
                canv.m[5] -= pt.y * customZoomAlpha;
            } else {
                canv.m[0] += zoomAlpha * canv.m[0];
                canv.m[3] += zoomAlpha * canv.m[3];

                canv.m[4] -= pt.x * zoomAlpha;
                canv.m[5] -= pt.y * zoomAlpha;
            }
        } else {
            if (
                canv.m[0] + zoomAlpha * canv.m[0] < this.getConstant(this.minZoom) ||
                canv.m[3] + zoomAlpha * canv.m[3] < this.getConstant(this.minZoom)
            ) {
                var customZoomAlpha = 1 - this.getConstant(this.minZoom) / canv.m[0];

                canv.m[0] = this.getConstant(this.minZoom);
                canv.m[3] = this.getConstant(this.minZoom);

                canv.m[4] += pt.x * customZoomAlpha;
                canv.m[5] += pt.y * customZoomAlpha;
            } else {
                canv.m[0] += zoomAlpha * canv.m[0];
                canv.m[3] += zoomAlpha * canv.m[3];

                canv.m[4] -= pt.x * zoomAlpha;
                canv.m[5] -= pt.y * zoomAlpha;
            }
        }

        // Обновляем отображаемый процент зума
        canv.updateZoomDisplay();

        canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
        canv.redraw();
    }

    // mini map

    updateMinimap = rafThrottle(() => {
        eventEmitter.dispatch("minimap.update", { needUpdate: true });
    });

    // Helpers

    softDragAction(zoomToVisProps) {
        var animation = new zoomToVis(zoomToVisProps, 15);
        canv.animator.deleteAnimation("zoomTo");
        canv.animator.addAnimation(animation);
        canv.redraw();
    }

    dragAction(x, y) {
        matrixTranslate(x, y);
        canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
        this.updateMinimap();
        canv.toolBox.TryAction("touchpadGestureDragging");

        canv.redraw();
    }

    async viewSaveSave(e) {
        if (!canv.isBoardModeFullRights()) return;

        const viewPort = getViewport();
        const request = {
            token: canv.getInitDataProp("userToken"),
            boardUID: canv.getInitDataProp("boardUID"),
            data: {
                viewportStartX: viewPort["viewportStartX"],
                viewportStartY: viewPort["viewportStartY"],
                viewportWidth: viewPort["viewportWidth"],
                viewportHeight: viewPort["viewportHeight"],
                scale: canv.m[0],
            },
        };

        await MakeRequest(BOARD_ZOOM_SET_V2, request, true, true, true);
    }

    async viewSaveLoad() {
        if (!canv.isBoardModeFullRights()) return;

        const zoom = await MakeRequest(
            BOARD_ZOOM_GET_V2,
            {
                token: canv.getInitDataProp("userToken"),
                boardUID: canv.getInitDataProp("boardUID"),
            },
            false,
            true,
        );

        // ручка niceToHave - может вернуть undefined
        if (zoom == undefined) {
            return;
        }

        if (zoom["status"] === "fail") {
            return;
        }

        // был кейс что пришел success с нулями. В таком случае мы не хотим туда зумить
        if (zoom["data"]["scale"] == 0) {
            return;
        }

        const centerX =
            zoom["data"]["viewportStartX"] + zoom["data"]["viewportWidth"] / 2;
        const centerY =
            zoom["data"]["viewportStartY"] + zoom["data"]["viewportHeight"] / 2;
        const maxScale = Math.max(
            zoom["data"]["scale"],
            this.getConstant(this.minZoom),
        );
        canv.m[0] = maxScale;
        canv.m[3] = maxScale;
        canv.m[4] = -(centerX - zoom["data"]["viewportWidth"] / 2) * canv.m[0];
        canv.m[5] = -(centerY - zoom["data"]["viewportHeight"] / 2) * canv.m[3];

        canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
        canv.updateZoomDisplay();
    }

    hasItemInViewport() {
        const currentViewport = getViewport();
        const itemsViewport = canv.canvasController.getSelectedProps(
            canv.canvasController.items,
        );

        if (
            currentViewport["viewportStartX"] + currentViewport["viewportWidth"] >=
            itemsViewport["startX"] &&
            currentViewport["viewportStartY"] + currentViewport["viewportHeight"] >=
            itemsViewport["startY"] &&
            currentViewport["viewportStartX"] <=
            itemsViewport["startX"] + itemsViewport["width"] &&
            currentViewport["viewportStartY"] <=
            itemsViewport["startY"] + itemsViewport["height"]
        ) {
            return true;
        }
    }

    zoomPlus() {
        var pt = {
            x: -canv.m[4] + canv.canvas.width / 2,
            y: -canv.m[5] + canv.canvas.height / 2,
        };
        canv.actionManager.handleZoomFor2(-20, pt);
    }

    zoomMinus() {
        var pt = {
            x: -canv.m[4] + canv.canvas.width / 2,
            y: -canv.m[5] + canv.canvas.height / 2,
        };
        canv.actionManager.handleZoomFor2(20, pt);
    }

    lastX = 0;
    lastY = 0;
    preX = 0;
    preY = 0;
    lastMoveEvt = null;

    mode = "trackpad";
    /** @type {Array} */
    prevTouches = [];
    /** @type {Array} */
    lastTouches = [];
    /** @type {string | undefined} */
    gestureType = undefined;
    rightButtonClicked = false;
    clickMove = 0;
    clickMoveThreshold = 3;

    // Constants
    maxZoom = 5;
    minZoom = 0.01;
}
